import BunkeyAPI from "../api/BunkeyAPI";
import {
  CLIENTS_GET_DATA,
  CLIENTS_GET_DATA_SUCCESS,
  CLIENTS_GET_DATA_FAILURE,
  CLIENTS_TYPE_GET_DATA,
  CLIENTS_TYPE_GET_DATA_SUCCESS,
  CLIENTS_TYPE_GET_DATA_FAILURE,
  CLIENTS_TYPE_BUSINESS_GET_DATA,
  CLIENTS_TYPE_BUSINESS_GET_DATA_SUCCESS,
  CLIENTS_TYPE_BUSINESS_GET_DATA_FAILURE
} from "../constants/client-types";
//import {GROUP_BY_CLIENT, GROUP_BY_CLIENT_FAILURE, GROUP_BY_CLIENT_SUCCESS} from "../constants/group-types";
//import {useState} from "react";

export const getClients = (activePage, limit = 10) => {
  return dispatch => {
    dispatch({ type: CLIENTS_GET_DATA });
    BunkeyAPI({
      url: `admin/clients?page=${activePage}&limit=${limit}`,
      method: "GET"
    })
      .then(resp => {
        dispatch({
          type: CLIENTS_GET_DATA_SUCCESS,
          payload: {
            data: resp.data,
            headers: resp.headers
          }
        });
      })
      .catch(err => {
        dispatch({
          type: CLIENTS_GET_DATA_FAILURE,
          payload: err
        });
      });
  };
};

export const getClientsByName = (activePage, name) => {
  return dispatch => {
    dispatch({ type: CLIENTS_GET_DATA });
    BunkeyAPI({
      url: `admin/clients?page=${activePage}&search=${name}`,
      method: "GET"
    })
      .then(resp => {
        dispatch({
          type: CLIENTS_GET_DATA_SUCCESS,
          payload: {
            data: resp.data,
            headers: resp.headers
          }
        });
      })
      .catch(err => {
        dispatch({
          type: CLIENTS_GET_DATA_FAILURE,
          payload: err
        });
      });
  };
};

export const getTypeClients = () => {
  return dispatch => {
    dispatch({ type: CLIENTS_TYPE_GET_DATA });
    BunkeyAPI({
      url: `/clients/type/clients`,
      method: "GET"
    })
      .then(resp => {
        dispatch({
          type: CLIENTS_TYPE_GET_DATA_SUCCESS,
          payload: {
            headers: resp.headers,
            data: resp.data
          }
        });
      })
      .catch(err => {
        dispatch({
          type: CLIENTS_TYPE_GET_DATA_FAILURE,
          payload: err
        });
      });
  };
};

export const getTypeBusinessClients = () => {
  return dispatch => {
    dispatch({ type: CLIENTS_TYPE_BUSINESS_GET_DATA });
    BunkeyAPI({
      url: `/clients/type/bussiness`,
      method: "GET"
    })
      .then(resp => {
        dispatch({
          type: CLIENTS_TYPE_BUSINESS_GET_DATA_SUCCESS,
          payload: {
            headers: resp.headers,
            datalist: resp.data
          }
        });
      })
      .catch(err => {
        dispatch({
          type: CLIENTS_TYPE_BUSINESS_GET_DATA_FAILURE,
          payload: err
        });
      });
  };
};

export const getWorkClients = workClients => {
  return dispatch => {
    dispatch({ type: CLIENTS_GET_DATA });
    let promiseClients = [];
    workClients.forEach(wc => {
      promiseClients.push(
        new Promise((resolve, reject) => {
          BunkeyAPI({
            url: `clients/${wc}`,
            method: "GET"
          })
            .then(resp => {
              resolve(resp);
            })
            .catch(err => {
              reject(err);
            });
        })
      );
    });
    Promise.all(promiseClients).then(
      values => {
        dispatch({
          type: CLIENTS_GET_DATA_SUCCESS,
          payload: {
            data: values.map(r => r.data),
            headers: values.map(r => r.headers)
          }
        });
      },
      reason => {
        dispatch({
          type: CLIENTS_GET_DATA_FAILURE,
          payload: reason
        });
      }
    );
  };
};
